import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, input, output, HostListener, OnChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { forkJoin } from 'rxjs';
import { AccessPermissionType } from 'src/app/bo/accessPermisionType';
import { WorkflowEtapeInstance } from 'src/app/bo/workflowEtapeInstance';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { Dossier } from '../../bo/dossier';
import { Fichier, DirectoryType } from '../../bo/fichier';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { ProprieteAffichee } from 'src/app/bo/proprieteAffichee';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakUtilisateurService } from 'src/app/services/keycloak/keycloak-utilisateur.service';
import { DocumentStorageService } from 'src/app/services/document-storage.service';

@Component({
  selector: 'app-file-explorer',
  templateUrl: './file-explorer.component.html',
  styleUrls: ['./file-explorer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FileExplorerComponent implements OnChanges {
  @ViewChild('modalFormDossier') modalFormDossier: ModalDirective;
  @ViewChild('modalConfirmSuppr') modalConfirmSuppr: ModalDirective;
  @ViewChild('modalRenommer') modalRenommer: ModalDirective;
  @ViewChild('modalConfirmUpload') modalConfirmUpload: ModalDirective;
  @ViewChild('modalUpload') modalUpload: ModalDirective;
  @ViewChild('modalDownload') modalDownload: ModalDirective;
  @ViewChild('modalFichiersSupprimes') modalFichiersSupprimes: ModalDirective;
  @ViewChild('modalErreurSynchro') modalErreurSynchro: ModalDirective;
  @ViewChild("fileInput") fileInput: ElementRef;
  racine = input<Dossier>();
  apiEndPoint = input<string>("");
  id = input<number|undefined>();
  hauteurExplorer = input<number>(0);
  /** Optional blast name, used to prefix the downloaded archive (blastName_folder.zip) */
  blastName = input<string>("");
  modifDossier = output<Dossier>();

  table_Width:number[] = [52,12,12,21];

  proprietesAffichees:ProprieteAffichee[] = [];

  racineBackup: Dossier;
  racineLocal: Dossier;
  files: Array<File>;
  selectBox: any;
  reverseOrder = false;
  timerClick: any;
  preventClick = false;
  couperEncours = false;
  mouseleave = true;
  dragging = false;
  progress = 0;
  interval: any;
  dossierCourant: Dossier = null;
  path = [];
  selectedFiles: Fichier[] = [];
  selectedFolders: Dossier[] = [];
  nomDossier: string;
  pressePapier:(Fichier|Dossier)[] = [];
  nvNom: string;
  totalSize = 0;
  warningDuplicateFile: boolean;
  downloadEnCours: boolean;
  dossierErreurNom: boolean;
  dossierNomRequis: boolean;
  renommageErreurNom: boolean;
  renommageNomRequis: boolean;
  isIE = false;
  poidsTotal: number;
  estErreurRenommage: boolean;
  nomDossierExistant: boolean;
  showIcon = true;
  accessPermision:AccessPermissionType;
  stepId: number;
  isGeneralSiteFiles:boolean;
  sortColumn = '';
  sortOrder = true;


  constructor(
    private readonly http: HttpService,
    private readonly fonctionsService: FonctionsService,
    private readonly cdRef: ChangeDetectorRef,
    public utilisateurService: UtilisateurService,
    private readonly userProfileService: KeycloakUtilisateurService,
    public router: Router,
    private readonly translate: TranslateService,
    private readonly documentStorageService: DocumentStorageService
    ) {
      this.proprietesAffichees.push(new ProprieteAffichee('file_name', 'GLOBAL.FILE_NAME'));
      this.proprietesAffichees.push(new ProprieteAffichee('file_type', 'GLOBAL.FILE_TYPE'));
      this.proprietesAffichees.push(new ProprieteAffichee('file_size', 'GLOBAL.FILE_SIZE'));
      this.proprietesAffichees.push(new ProprieteAffichee('modified', 'GLOBAL.CREATION'));

    if (navigator.userAgent.match(/Edge/i) || navigator.userAgent.match(/Trident.*rv[ :]*11\./i)) {
      this.isIE = true;
    }
    else {
      this.isIE = false;
    }
    
  }


  //premier init du composant + detection changement de site depuis le selecteur de site (monSite change dans le composant monSite) (changes.racine)
  ngOnChanges() {
    this.setStepIdFromUrl();
    this.setworkflowEtapeInstance();
    if (this.racine()) {
      this.racineLocal = this.racine();
      // Si on modifie un élément, l'event modifDossier est lancé et met à jour l'objet venu du parent
      // L'objet du parent est modifié et donc on passe dans le ngOnChanges du file explorer
      // Néanmoins le dossierCourant est initialisé et n'a pas de raison de changé, de même que le path
      if (!this.dossierCourant || (this.racineLocal.dossierParent == null && this.racineLocal.dossierId != this.racineBackup.dossierId)) {
        this.dossierCourant = this.racineLocal;
        this.path = []; //réinit path au changement de site
        this.path.push(this.racineLocal.nom);
        this.racineBackup = JSON.parse(JSON.stringify(this.racineLocal));
      }
      this.clearSelection();
      this.tri(false);
    }
  }

  ngOnInit(): void {
    this.isGeneralSiteFiles = this.dossierCourant.nom === this.utilisateurService.currentSite()?.nom;
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event) {
    if (this.downloadEnCours || this.progress != 0)
      $event.returnValue = '';
  }

  /**
   *  Listener detection de couper coller : ctrl+X et ctrl+V
   * @param $event
   */
  @HostListener('window:keydown', ['$event'])
  onKeyPress($event: Event) {
    const event = $event as KeyboardEvent;

    if(this.selectedFiles.length == 0) return;

    //CTRL + X (metaKey pour touche cmd Mac)
    if ((event.ctrlKey || event.metaKey) && event.keyCode == 88 && (this.selectedFiles.length > 0 || this.selectedFolders.length > 0)) {
    
      this.pressePapier = this.selectedFiles;
      // this.pressePapier.push(...this.selectedFolders);
      this.clearSelection();
      this.couperEncours = true;
    }
    //CTRL + V (metaKey pour touche cmd Mac)
    if ((event.ctrlKey || event.metaKey) && event.keyCode == 86) {
      this.coller();
    }
    // Appuie sur touche [Del]
    if (event.keyCode == 46 && (this.selectedFiles.length > 0 || this.selectedFolders.length > 0))
      this.modalConfirmSuppr.show();
  }

  protected getFileExtension(fName:string){
    return '.' + fName.slice((fName.lastIndexOf(".") - 1 >>> 0) + 2);
  }

  protected removeExtension(fName) {
    return fName.substring(0, fName.lastIndexOf('.')) || fName;
  }
  
  private setStepIdFromUrl(){
    let lastUrlParam = this.router.url.split('&').pop();
    if(lastUrlParam.includes('=')){
      this.stepId = Number(lastUrlParam.split('=').pop());
    }
    else this.stepId = undefined;
  }

  private setworkflowEtapeInstance(){
    if(undefined !== this.stepId && this.stepId != null && !isNaN(this.stepId)) {
      this.http.get('WorkflowSteps/' + this.stepId  +'/WorkflowStepInstanceById').subscribe((res:WorkflowEtapeInstance) => {
        this.accessPermision = res.accessPermission;
        this.showIcon = this.clientReadWrite();
        this.cdRef.detectChanges();
        },(error: HttpErrorResponse)=>{
          if(error.status === 401 || error.status === 403){
        console.log(error.error);
          }
          else if(error.status === 404 ){
            this.showIcon = true;
            this.accessPermision = AccessPermissionType.READANDWRITE;
          }
        })
    }
    
  }

  protected bytesToMb(bytes:number){
      return (bytes / (1024 * 1024)).toFixed(2);
  }

  private  isFichier(f: Fichier | Dossier): f is Fichier {
    return (<Fichier>f).fichierId !== undefined;
 }

  /***
   *  Fonction coller clique sur le btn ou ctrl+V
   * */
  coller() {
    this.estErreurRenommage = false;
    if (this.couperEncours && this.pressePapier.length > 0 && !this.pressePapier.find(p => {
       if( !this.isFichier(p)){
        return (p.dossierId == this.dossierCourant.dossierId) || (p.dossierParentId == this.dossierCourant.dossierId)
        }})){
      let fichiers = [];
      let dossiers = [];
      this.fonctionsService.loading_screen(true);
      this.pressePapier.forEach(item => {
        if (this.isFichier(item)) { //est fichier
          fichiers.push(item);
        } else {  //est dossier
          dossiers.push(item);
        }
      });
      let rqArr = [];

      if (dossiers.length > 0)
        rqArr.push(this.http.post(this.apiEndPoint() + "/" + this.id() + "/Folders/MoveTo/" + this.dossierCourant.dossierId, dossiers));
      if (fichiers.length > 0)
        rqArr.push(this.http.post(this.apiEndPoint() + "/" + this.id() + "/Files/MoveTo/" + this.dossierCourant.dossierId, fichiers));

      forkJoin(rqArr).subscribe((res: any) => {
        this.racineLocal = res[rqArr.length - 1];
        this.refreshDossierCourant(this.racineLocal);
        this.modifDossier.emit(this.racineLocal);
        this.clear();
        this.fonctionsService.loading_screen(false);
      },
        (err: any) => {
          this.clear();
          // En cas d'erreur, on rafraîchit le dossier et on affiche le message indiquant que le dossier de destination a déjà été supprimé physiquement
          this.http.get<Dossier>(this.apiEndPoint() + "/" + this.id() + '/Folder').subscribe((res: Dossier) => {
            this.racineLocal = res;
            this.refreshDossierCourant(this.racineLocal);
            this.modifDossier.emit(this.racineLocal);
          });
          this.fonctionsService.loading_screen(false);
          this.modalErreurSynchro.show();
        }
      );
    } else {
      this.fonctionsService.loading_screen(false);
      this.couperEncours = false;
      this.pressePapier = [];
    }
  }

 protected cancelColler(){
  this.couperEncours = false;
  this.pressePapier = [];
  this.clearCheckboxs();
  this.clearSelection();
  }

  /*
   * Fonction couper clique sur le btn ou ctrl+X
   * */
  couper() {
    if (this.selectedFiles.length > 0 || this.selectedFolders.length > 0) {
      
      this.pressePapier = this.selectedFiles;
      // this.pressePapier.push(...this.selectedFolders);
      // this.pressePapier = this.selectedFiles.concat(this.selectedFolders);
      this.clearSelection();
      this.couperEncours = true;
    }
  }

  /**
   * Vider la selection ou annuler couper/coller
   * */
  clear() {
    this.clearSelection();
    this.pressePapier = [];
    this.couperEncours = false;
    this.fonctionsService.loading_screen(false);
  }

  /**
   * Renommer un fichier un dossier
   * */
  renommer(e: any) {
  
    this.renommageErreurNom = false;
    this.renommageNomRequis = false;
    this.estErreurRenommage = true;
    if (!this.verifierNomFichierDossier(this.nvNom, 'renommageErreurNom', 'renommageNomRequis'))
      return false;

    this.fonctionsService.loading_screen(true);
    let requete = this.selectedFiles.length ? this.http.put<string, Dossier>(this.apiEndPoint() + "/" + this.id() + "/Files/" + this.selectedFiles[0].fichierId, this.nvNom) :
      this.http.put<string, Dossier>(this.apiEndPoint() + "/" + this.id() + "/Folders/" + this.selectedFolders[0].dossierId, this.nvNom);

    requete.subscribe((res: Dossier) => {
      this.racineLocal = res;
      this.refreshDossierCourant(this.racineLocal);
      this.modifDossier.emit(this.racineLocal);
      this.modalRenommer.hide();
      this.nvNom = "";
      this.clear();
      this.fonctionsService.loading_screen(false);
    }, () => {
      // En cas d'erreur, on rafraîchit le dossier et on affiche le message indiquant que le fichier a déjà été supprimé physiquement
      this.http.get(this.apiEndPoint() + "/" + this.id() + '/Folder').subscribe((res: Dossier) => {
        this.racineLocal = res;
        this.refreshDossierCourant(this.racineLocal);
        this.modifDossier.emit(this.racineLocal);
      });
      this.modalRenommer.hide();
      this.clear();
      this.fonctionsService.loading_screen(false);
      this.modalErreurSynchro.show();
    });
  }

  /**
   * fonction ajour d'un dossier après clique suyr le btn
   * @param e event html
   */
  addFolder(e: any) {
    this.dossierErreurNom = false;
    this.dossierNomRequis = false;
    this.nomDossierExistant = this.dossierCourant.sousDossiers.find(o => o.nom == e.target[0].value.trim()) !== undefined;

    if (!this.verifierNomFichierDossier(e.target[0].value, 'dossierErreurNom', 'dossierNomRequis') || this.nomDossierExistant)
      return false;

    this.fonctionsService.loading_screen(true);
    var nvDossier = new Dossier();
    nvDossier.dossierParentId = this.dossierCourant.dossierId;
    nvDossier.nom = e.target[0].value;
    this.http.post<Dossier, Dossier>(this.apiEndPoint() + '/' + this.id() + '/Folders/Add', nvDossier).subscribe((res: Dossier) => {
      this.racineLocal = res;
      this.refreshDossierCourant(this.racineLocal);
      this.modifDossier.emit(this.racineLocal);
      e.target[0].value = "";
      this.modalFormDossier.hide();
      this.clearSelection();
    }, () => { },
      () => this.fonctionsService.loading_screen(false));
  }

  protected selectFile(e: any, item: Fichier){
      if (this.couperEncours) return;
      item.isSelected = !item.isSelected
      if(item.isSelected){
          this.selectedFiles.push(item);
          if(this.selectedFiles.length == 1 && (this.poidsTotal === 0 || this.poidsTotal === this.calculerTailleDossier(this.dossierCourant))){
            this.poidsTotal = item.taille;
          }else{
            this.poidsTotal += item.taille;
          }
        }else{
          const index = this.selectedFiles.findIndex(i => i.fichierId === item.fichierId)
          if(index > -1){
            this.selectedFiles.splice(index,1);
  
            if(this.poidsTotal > 0){
              this.poidsTotal -= item.taille;
            }
  
          }
        }
  }

  // selectFile(e: any, item: Fichier) {
  //   item.isSelected = !item.isSelected;
  //   if (!this.preventClick) {
  //     this.couperEncours = false;
  //     this.pressePapier = [];
  //     if (this.selectedFiles.length == 0 && !e.ctrlKey) {
  //       this.selectedFolders = [];
  //       this.selectedFiles.push(item);
  //       this.poidsTotal = item.taille;
  //     } else if (e.ctrlKey) {enter
  //       if (this.selectedFiles.includes(item)) {
  //         this.selectedFiles = this.selectedFiles.filter(p => p.fichierId != item.fichierId);
  //         if (this.selectedFiles.length == 0 && this.selectedFolders)
  //           this.poidsTotal = this.calculerTailleDossier(this.dossierCourant);
  //         else
  //           this.poidsTotal -= item.taille;
  //       } 
  //     } else {

  //   console.log(item);

  //       if(item.isSelected){
  //         this.selectedFiles.push(item);
  //         this.poidsTotal += item.taille;
  //       }else{
  //         const index = this.selectedFiles.findIndex(i => i.fichierId === item.fichierId)
  //         console.log(index);

  //         if(index > -1){
  //           this.selectedFiles = this.selectedFiles.splice(index,1);
  //           this.poidsTotal = item.taille;
  //           console.log(this.selectedFiles);
  //         }
  //       }
  //       // this.clearSelection();
  //     }
  //   }

  //   console.log(this.selectedFiles);
  //   this.preventClick = false;
  // }

  selectFolder(e: any, item: Dossier){
    if (this.couperEncours) return;
    item.isSelected = !item.isSelected;
    if(item.isSelected){
      this.selectedFolders.push(item);
      if(this.selectedFolders.length == 1  && (this.poidsTotal === 0 || this.poidsTotal === this.calculerTailleDossier(this.dossierCourant))){
        this.poidsTotal = this.calculerTailleDossier(item);
      }else{
        this.poidsTotal += this.calculerTailleDossier(item);
      }
    }else{
      const index = this.selectedFolders.findIndex(i => i.dossierId === item.dossierId)
      if(index > -1){
        this.selectedFolders.splice(index,1);
        if(this.poidsTotal > 0){
          this.poidsTotal -= this.calculerTailleDossier(item);
        }
      }
    }
  }

  // selectFolder(e: any, item: any) {
  //   item.isSelected = !item.isSelected;
  //   if (this.couperEncours) return;
  //   if (!this.preventClick) {
  //     if (this.selectedFolders.length == 0 && !e.ctrlKey) {
  //       this.selectedFolders.push(item);
  //       this.selectedFiles = [];
  //       this.poidsTotal = this.calculerTailleDossier(item);
  //     } else if (e.ctrlKey) {
  //       if (this.selectedFolders.includes(item)) {
  //         this.selectedFolders = this.selectedFolders.filter(p => p.dossierId != item.dossierId);
  //         if (this.selectedFiles.length == 0 && this.selectedFolders.length == 0)
  //           this.poidsTotal = this.calculerTailleDossier(this.dossierCourant);
  //         else
  //           this.poidsTotal -= this.calculerTailleDossier(item);
  //       } else {
  //         this.selectedFolders.push(item);
  //         this.poidsTotal += this.calculerTailleDossier(item);
  //       }
  //     } else {
  //       this.clearSelection();
  //       this.selectedFolders.push(item);
  //       this.poidsTotal = this.calculerTailleDossier(item);
  //     }
  //   }
  //   this.preventClick = false;
  // }

  /**
   * Clear les tableaux de sélection en cas de clique sur une zone libre de l'explorateur
   * @param e
   */
  clearSelectedItems(e: any) {
    if (e.target.className == "content") {
      this.clearSelection();
    }
  }

  clearSelection() {
    this.selectedFiles = [];
    this.selectedFolders = [];
    this.poidsTotal = this.calculerTailleDossier(this.dossierCourant);
  }

  clearCheckboxs() {
    this.dossierCourant.fichiers.forEach(fichier => {
      fichier.isSelected = false;
    });
    this.dossierCourant.sousDossiers.forEach(dossier => {
      dossier.isSelected = false;
    });
  }

  /**
   * Appeler sur event dragstart d'un dossier. Annule les actions en cours et déplace le tooltip
   * @param e
   * @param item dossier déplacé
   */
  onDragStartFolder(e: any, item: Dossier) {
    this.dragging = true;
    this.couperEncours = false;
    this.pressePapier = [];
    if (!this.selectedFolders.includes(item)) {
      this.selectedFolders.push(item);
      this.poidsTotal += this.calculerTailleDossier(item);
    }
  }

  /**
  * Appeler sur event dragstart d'un ficiher. Annule les actions en cours et déplace le tooltip
  * @param e
  * @param item fichier déplacé
  */
  onDragStartFile(e: any, item: Fichier) {
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      e.dataTransfer.setData('text/plain', null);
    }
    this.dragging = true;
    this.couperEncours = false;
    this.pressePapier = [];
    if (!this.selectedFiles.includes(item)) this.selectedFiles.push(item);
  }

  /**
   * Annuler le comportement par défaut du naviguateur sur la dépose d'un élément
   * @param e event html
   */
  onDragEnd(e: any) {
    if (e) e.preventDefault();
    this.dragging = false;
  }

  /**
   * Annuler le comportement par défaut du naviguateur sur la dépose d'un élément
   * @param e event html
   */
  dragOverContent(e: any) {
    e.preventDefault();
  }

  /**
   * Drag and drop de fichier dans l'explorateur : Ajoute le classe css de la zone de drop
   * @param e
   */
  onDragEnter(e: any) {
    e.preventDefault();
    if (!this.dragging) {
      e.target.classList.add("dragover");
      this.clearSelection();
    }
  }

  /**
  * Annuler le comportement par défaut du naviguateur sur la dépose d'un élément
  * @param e event html
  */
  dragoverFolder(e: any) {
    e.preventDefault();
  }

  /**
   * Drag and drop de fichier dans l'explorateur : Supprime le classe css de la zone de drop
   * @param e
   */
  onDragLeave(e: any) {
    e.preventDefault();
    if (!this.dragging) {
      e.target.classList.remove("dragover");
    }
  }

  /**
   * Déplace un dossier et son contenu dans un autre dossier
   * @param d dossier déplacé
   */
  deplacerIci(d: Dossier) {
    this.estErreurRenommage = false;
    if (!this.selectedFolders.includes(d)) {
      this.fonctionsService.loading_screen(true);
      let rqArr = [];

      if (this.selectedFolders.length > 0) rqArr.push(this.http.post(this.apiEndPoint() + "/" + this.id() + "/Folders/MoveTo/" + d.dossierId, this.selectedFolders));
      if (this.selectedFiles.length > 0) rqArr.push(this.http.post(this.apiEndPoint() + "/" + this.id() + "/Files/MoveTo/" + d.dossierId, this.selectedFiles));

      forkJoin(rqArr).subscribe((res: any) => {
        this.racineLocal = res[rqArr.length - 1];
        this.refreshDossierCourant(this.racineLocal);
        this.modifDossier.emit(this.racineLocal);
        this.clear();
        this.fonctionsService.loading_screen(false);
      },
        (err: any) => {
          this.clear();
          // En cas d'erreur, on rafraîchit le dossier et on affiche le message indiquant que le dossier de destination a déjà été supprimé physiquement
          this.http.get<Dossier>(this.apiEndPoint() + "/" + this.id() + '/Folder').subscribe((res: Dossier) => {
            this.racineLocal = res;
            this.refreshDossierCourant(this.racineLocal);
            this.modifDossier.emit(this.racineLocal);
          });
          this.modalErreurSynchro.show();
          this.fonctionsService.loading_screen(false);
        }
      );
    }
  }

  /**
   * Ajout des fichiers dans la base
   * @param files
   */
  uploadFiles(files: File[]) {
    this.clearSelection();
    this.modalConfirmUpload.hide();
    this.modalUpload.show();
    if (files.length == 0) return;

    const frmData = new FormData();
    for (var i = 0; i < files.length; i++) {
      let filename = files[i].name;
      if (this.isIE) {
        let arrFilename = files[i].name.split("\\");
        filename = arrFilename[arrFilename.length - 1];
      }
      frmData.append(filename, files[i]);
    }
    frmData.append("dossierId", this.dossierCourant.dossierId.toString());

    this.http.request('POST', this.apiEndPoint() + '/' + this.id() + '/Files/Upload?siteId=' + this.utilisateurService.currentSite()?.siteId, frmData).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress = Math.trunc((event.loaded / event.total) * 100);
          this.cdRef.detectChanges();
          var x = document.getElementById("progressbar");
          x.style.width = this.progress.toString() + "%";
        }

        if (event.type === HttpEventType.Response) {
          this.racineLocal = <Dossier>event.body;
          this.refreshDossierCourant(this.racineLocal);
          this.modifDossier.emit(this.racineLocal);
          this.progress = 0;
          this.modalUpload.hide();
          this.fileInput.nativeElement.value = null;
        }
      },
      (err: any) => {
        this.progress = 0;
        this.modalUpload.hide();
      }
    );
  }

  /**
   * Ouverture de l'explorateur windows pour selectionner les fichiers à ajouter
   * @param e
   */
  filesFromInput(e: any) {
    this.clearSelection();
    this.couperEncours = false;
    this.pressePapier = [];
    this.files = e.srcElement.files;
    this.totalSize = 0;
    this.warningDuplicateFile = false;
    if (this.files.length > 0) {
      for (let i = 0; i < this.files.length; i++) {
        let nom = this.files[i].name;
        let indexPoint = this.files[i].name.lastIndexOf('.');
        if (indexPoint != -1)
          nom = this.files[i].name.substr(0, indexPoint) + this.files[i].name.substr(indexPoint).toLowerCase();

        if (this.dossierCourant.fichiers.find(p => p.nom == nom)) {
          this.warningDuplicateFile = true;
        }
        this.totalSize += this.files[i].size;
      }
      this.modalConfirmUpload.show();
    }
  }

  /**
   * Affichage de la modale d'ajout de fichier depuis un drop
   * @param e
   */
  filesFromDrop(e: any) {
    e.preventDefault();
    if(!this.clientReadWrite()){
      this.translate.get('GLOBAL.NON_AUTORISE_SAVE').subscribe(trad => {
        this.fonctionsService.launch_toast(false, false, trad);
        return;
      });
    }
    else if (e.dataTransfer.files.length > 0) {
      this.clearSelection();
      this.couperEncours = false;
      this.pressePapier = [];
      this.totalSize = 0;
      this.warningDuplicateFile = false;
      document.getElementById("explorer-content").classList.remove("dragover");
      this.files = e.dataTransfer.files;
      for (let i = 0; i < this.files.length; i++) {
        let nom = this.files[i].name;
        let indexPoint = this.files[i].name.lastIndexOf('.');
        if (indexPoint != -1)
          nom = this.files[i].name.substr(0, indexPoint) + this.files[i].name.substr(indexPoint).toLowerCase();

        if (this.dossierCourant.fichiers.find(p => p.nom == nom)) {
          this.warningDuplicateFile = true;
        }
        this.totalSize += this.files[i].size;
      }
      this.modalConfirmUpload.show();
    }
  }

  /**
   *  Suppression des éléments selectionnés
   * */
  deleteItems() {
    let rqArr = [];
    this.fonctionsService.loading_screen(true);
    if (this.selectedFolders.length > 0) rqArr.push(this.http.post(this.apiEndPoint() + "/" + this.id() + "/Folders/Delete", this.selectedFolders));
    if (this.selectedFiles.length > 0) rqArr.push(this.http.post(this.apiEndPoint() + "/" + this.id() + "/Files/Delete", this.selectedFiles));

    forkJoin(rqArr).subscribe((res: any) => {
      this.racineLocal = res[res.length - 1];
      this.refreshDossierCourant(this.racineLocal);
      this.modifDossier.emit(this.racineLocal);
      this.modalConfirmSuppr.hide();
      this.selectedFolders = [];
      this.selectedFiles = [];
      this.fonctionsService.loading_screen(false);
    }, (err: any) => {
      this.progress = 0;
      this.selectedFolders = [];
      this.selectedFiles = [];
      this.fonctionsService.loading_screen(false);
    });
  }

  /**
   * Rafraichit le contenu du dossier courant après une opération
   * @param d
   */
  refreshDossierCourant(d: Dossier) {
    if (d.dossierId == this.dossierCourant.dossierId) {
      this.dossierCourant = d;
      this.poidsTotal = this.calculerTailleDossier(this.dossierCourant);
    }
    else {
      d.sousDossiers.forEach(_d => {
        this.refreshDossierCourant(_d);
      });
    }
  }

  /**
   * Se déplacer dans un dossier enfants (dblclique)
   * @param d
   */
  enterFolder(d: Dossier) {
    clearTimeout(this.timerClick);
    this.preventClick = true;
    if (this.couperEncours && this.pressePapier.find(p => p.dossierId == d.dossierId)) { //Annulation du couper coller en cours
      this.pressePapier = [];
    }
    this.dossierCourant = d;
    this.path.push(d.nom);
    this.clearSelection();
    this.clearCheckboxs();
    this.tri(false);
    this.preventClick = false;
  }

  /**
   * Ouvre un fichier dans un nouvel onglet ou lance un téléchargement si le fichier n'est pas un pdf ou une image
   * @param fichier
   * @param fileType = USERFILES = 2
   * 
   */
  openFile(fichier: Fichier) {
    // Show the spinner
    this.fonctionsService.loading_screen(true);
    this.preventClick = true;
  
    const fichierDossier = new FichierDossier();
    fichierDossier.fichiers = [fichier];
    if(fichier.storedInS3){
          const  s3key = `${fichier.siteId}/${this.documentStorageService.getS3Folder(this.apiEndPoint())}/${fichier.dossierId}/${fichier.nom}`;
      this.documentStorageService.getDownloadUrl(s3key,fichier.fichierId, fichier.siteId, DirectoryType.USERFILES).subscribe({
        next: (result) => {
            if (result && result.downloadUrl) {
              window.open(result.downloadUrl, '_blank');
              this.fonctionsService.loading_screen(false);
            }
        },
        error: (error: HttpErrorResponse) => {
          this.handleError(error);
        },
      });
    }
    else{
 // Check if the file exists
    this.http.post<FichierDossier, Boolean>('Files/ExistFiles?fileType=' + DirectoryType.USERFILES, fichierDossier).subscribe({
      next: (resultat) => {
        if (resultat) {
          const query = this.buildFileQuery(fichier);
  
          // Download the file
          this.downloadFile(query, fichier.nom);
        } else {
          this.handleFileNotFound();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
    }
   
  }
  
  /**
   * Builds the query URL for the file download.
   */
  private buildFileQuery(fichier: Fichier): string {
    if (this.isGeneralSiteFiles) {
      return `Files/${fichier.fichierId}/OpenDocumentsSite/${fichier.siteId}`;
    } else {
      return `Files/${fichier.fichierId}/Open/${fichier.siteId}?fileType=${DirectoryType.USERFILES}`;
    }
  }
  
  /**
   * Handles the file download process.
   */
  private downloadFile(query: string, fileName: string) {
    this.http.downloadFile(query).subscribe({
      next: (res) => {
        if (res) {
          this.triggerFileDownload(res.body, fileName);
        } else {
          this.handleDownloadError();
        }
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }
  
  /**
   * Triggers the file download in the browser.
   */
  private triggerFileDownload(fileData: BlobPart, fileName: string) {
    const blob = new Blob([fileData], { type: 'base64' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
  
    // Trigger the download
    a.click();
  
    // Ensure the spinner remains visible until the download dialog appears
    setTimeout(() => {
      a.remove();
      this.fonctionsService.loading_screen(false); // Hide spinner
    }, 1000); // Adjust delay if necessary
  }
  
  /**
   * Handles the case where the file does not exist.
   */
  private handleFileNotFound() {
    this.fonctionsService.launch_toast(false, false, 'File not found');
    this.fonctionsService.loading_screen(false); // Hide spinner
  }
  
  /**
   * Handles errors during the file download process.
   */
  private handleDownloadError() {
    this.fonctionsService.launch_toast(false, false, 'Error during file download');
    this.fonctionsService.loading_screen(false); // Hide spinner
  }
  
  /**
   * Handles general errors.
   */
  private handleError(error: HttpErrorResponse) {
    console.error('Error:', error);
    this.fonctionsService.launch_toast(false, false, 'An error occurred');
    this.fonctionsService.loading_screen(false); // Hide spinner
  }
  /**
   * Retour à la racine de l'arborescence  (clique btn)
   * */
  goToRacine() {
    this.dossierCourant = this.racineLocal;
    this.path = [this.racineLocal.nom];
    this.modifDossier.emit(this.racineLocal);
    this.clearSelection();
    this.clearCheckboxs();
    this.tri(false);
  }

  /**
   * Retour au dossier parent (clique btn)
   * @param dossier
   */
  goToParent(dossier: Dossier) {
    this.clearSelection();
    this.clearCheckboxs();
    if (this.dossierCourant.dossierParentId == dossier.dossierId) {
      this.dossierCourant = dossier;
      this.poidsTotal = this.calculerTailleDossier(this.dossierCourant);
      this.path.pop();
      this.tri(false);
      return;
    }
    dossier.sousDossiers.forEach((d: Dossier) => {
      if (d.dossierId == this.dossierCourant.dossierParentId) {
        this.dossierCourant = d;
        this.path.pop();
        this.poidsTotal = this.calculerTailleDossier(this.dossierCourant);
        this.tri(false);
        return;
      }
      if (d.sousDossiers) this.goToParent(d);
    });
  }

  /**
   * tri du contenu courant par ordre alphabétique asc ou desc
   * */
  tri(changementSens = true) {
    if (changementSens)
      this.reverseOrder = !this.reverseOrder;
    if (!this.reverseOrder) {
      if (this.dossierCourant.sousDossiers && this.dossierCourant.sousDossiers.length > 0) {
        this.dossierCourant.sousDossiers.sort((a: any, b: any) => {
          var valA = a.nom;
          var valB = b.nom;
          if (!valA)
            return -1;
          if (!valB)
            return 1;
          if (valA.toLowerCase() < valB.toLowerCase())
            return -1;
          if (valA.toLowerCase() > valB.toLowerCase())
            return 1;
          return 0;
        });
      }
      if (this.dossierCourant.fichiers && this.dossierCourant.fichiers.length > 0) {
        this.dossierCourant.fichiers.sort((a: any, b: any) => {
          var valA = a.nom;
          var valB = b.nom;
          if (!valA)
            return -1;
          if (!valB)
            return 1;
          if (valA.toLowerCase() < valB.toLowerCase())
            return -1;
          if (valA.toLowerCase() > valB.toLowerCase())
            return 1;
          return 0;
        });
      }
    } else {
      if (this.dossierCourant.fichiers && this.dossierCourant.fichiers.length > 0) {
        this.dossierCourant.fichiers.sort((a: any, b: any) => {
          var valA = a.nom;
          var valB = b.nom;
          if (!valA)
            return 1;
          if (!valB)
            return -1;
          if (valA.toLowerCase() > valB.toLowerCase())
            return -1;
          if (valA.toLowerCase() < valB.toLowerCase())
            return 1;
          return 0;
        });
      }
      if (this.dossierCourant.sousDossiers && this.dossierCourant.sousDossiers.length > 0) {
        this.dossierCourant.sousDossiers.sort((a: any, b: any) => {
          var valA = a.nom;
          var valB = b.nom;
          if (!valA)
            return 1;
          if (!valB)
            return -1;
          if (valA.toLowerCase() > valB.toLowerCase())
            return -1;
          if (valA.toLowerCase() < valB.toLowerCase())
            return 1;
          return 0;
        });
      }
    }
  }

  /**
   * Affichage la modale pour renommer le fichier selectionné
   **/
  openModalRenommer() {
    this.clearCheckboxs();
    this.renommageErreurNom = false;
    this.renommageNomRequis = false;
    if (this.selectedFiles[0]) {
      this.nvNom = this.selectedFiles[0].nom.split(".")[0];
    } else {
      this.nvNom = this.selectedFolders[0].nom;
    }
    this.modalRenommer.show();
    setTimeout(() => {
      document.getElementById('nvNom').focus();
    }, 500);
  }

  /**
   * Affichage de la modale pour créer un dossier
   **/
  openModalCreerDossier() {
    this.dossierErreurNom = false;
    this.dossierNomRequis = false;
    this.nomDossierExistant = false;
    this.modalFormDossier.show();
    setTimeout(() => {
      document.getElementById('nomDossier').focus();
    }, 500);
  }

  /**
   *
   *
   * */
  hideModalConfirmUpload() {
    this.modalConfirmUpload.hide();
    // Si on sélectionne une première fois un fichier, qu'on l'annule l'upload, puis qu'on réouvre la modale et qu'on re selectionne ce même fichier
    // et que l'on ne réinitialise pas la propriété value de l'input (comme si dessous), alors l'input ne détecte pas de changement et l'event onChange n'est pas appelé
    this.fileInput.nativeElement.value = null;
  }

  /**
   * Sélection de tous les fichiers/dossiers affichés
   **/
  toutSelectionner() {
    this.clearSelection();
    this.poidsTotal = 0;
    this.dossierCourant.fichiers.forEach(fichier => {
      fichier.isSelected = true;
      this.selectedFiles.push(fichier);
      this.poidsTotal += fichier.taille;
    });
    this.dossierCourant.sousDossiers.forEach(dossier => {
      dossier.isSelected = true;
      this.selectedFolders.push(dossier);
      this.poidsTotal += this.calculerTailleDossier(dossier);
    });
  }

  protected selectAll(){
    if( this.selectedFiles.length + this.selectedFolders.length  === this.dossierCourant.fichiers.length + this.dossierCourant.sousDossiers.length){
     this.clearSelection();
     this.clearCheckboxs();
    }else{
      this.toutSelectionner();
    }
  }

  protected checkIfFileCanBePreview(f: Fichier){
    const filesAllowedToPreview = ['.png', '.jpg', '.jpeg', '.pdf'];
    const fileExtension = this.getFileExtension(f.nom); 
    return filesAllowedToPreview.includes(fileExtension);
  }

  
  protected openFileInNewWindow(f: Fichier,e:any){
    if(f.storedInS3){
      const s3key = `${f.siteId}/${this.documentStorageService.getS3Folder(this.apiEndPoint())}/${f.dossierId}/${f.nom}`;
        this.documentStorageService.getDownloadUrl(s3key, f.fichierId, f.siteId, DirectoryType.USERFILES).subscribe({
          next: (result) => {   
            if (result && result.downloadUrl) {
              window.open(result.downloadUrl, '_blank');
            }
          },
          error: (error: HttpErrorResponse) => {
            if(error.status === 404){
              this.translate.get('GLOBAL.NO_FILE_FOUND').subscribe(trad => {
                this.fonctionsService.launch_toast(false, false, trad);
              });
             }
          },
        }); 
  }else
    {
      e.stopPropagation()
    const url = 'Files/' + f.fichierId + '/Open/' + f.siteId + '/?fileType=2';
    this.http.openFile(url).pipe(map(
      (res:any) => {
          return new Blob([res], { type: res.type });
      })).subscribe(res => {
        const fileURL = URL.createObjectURL(res);
        window.open(fileURL, '_blank');
      },(error:HttpErrorResponse)=>{
           if(error.status === 404){
            this.translate.get('GLOBAL.NO_FILE_FOUND').subscribe(trad => {
              this.fonctionsService.launch_toast(false, false, trad);
            });
           }
      });}
  }

  /**
   * Lance le téléchargement de la sélection
   **/
  telecharger() {
    if (this.selectedFiles.length == 1 && this.selectedFolders.length == 0) {
      this.openFile(this.selectedFiles[0]);
    } else {
      let startLoader = setTimeout(() => {
        this.fonctionsService.loading_screen(true);
      }, 300);

      let body = new FichierDossier();
      body.dossiers = this.selectedFolders;
      body.fichiers = this.selectedFiles;
      let fileCategory = this.documentStorageService.getCurrentFileCategory(this.apiEndPoint());
        clearTimeout(startLoader);
        this.fonctionsService.loading_screen(false);
        // Ils existent tous -> on lance le dl
       {
          let startLoader = setTimeout(() => {
            this.modalDownload.show();
          }, 300);
          this.downloadEnCours = true;

            this.http.downloadFilePost(`Files?fileCategory=${fileCategory}`, body).subscribe({
            next: (resultat: any) => {
              const blob = new Blob([resultat], { type: 'application/zip' });
              const url = window.URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = url;
              a.download = this.buildArchiveName();
              document.body.appendChild(a);
              a.click();

              this.modalDownload.hide();
              this.downloadEnCours = false;
              clearTimeout(startLoader);
              setTimeout(() => {
              a.remove();
              }, 100);
            },
            error: (error: HttpErrorResponse) => {
              this.modalDownload.hide();
              this.downloadEnCours = false;
              clearTimeout(startLoader);
              this.fonctionsService.launch_toast(false, false, '');
            }
            });
        }
    }
  }

  /**
   * Builds the downloaded archive name.
   * Prefixed with the blast name when the explorer is opened from a blast,
   * so users can tell apart folders sharing the same name (e.g. "Area Mapping").
   */
  private buildArchiveName(): string {
    return this.fonctionsService.buildArchiveName(this.blastName(), this.dossierCourant?.nom ?? '');
  }

  /**
   * Valide ou le nom d'un fichier/dossier
   * @param valeur valeur du nom
   * @param varCharSpec nom du boolean indiquant un nom de fichier en erreur à cause de caractères spéciaux
   * @param varValVide nom du boolean indiquant que le nom de fichier est vide
   */
  verifierNomFichierDossier(valeur: string, varCharSpec: string, varValVide: string) {
    let tabChar = ['/', '\\', ':', '*', '?', '"', '<', '>', '|', '.'];

    this[varValVide] = valeur == null || valeur.trim() == '';

    for (var i = 0; i < valeur.length; i++) {
      let char = valeur[i];
      if (tabChar.find(o => o == char) != undefined)
        this[varCharSpec] = true;
    }
    return !this[varValVide] && !this[varCharSpec];
  }

  /**
   * Calcul du poids du dossier, soit le poids des fichiers qu'il contient plus le poids de ses sous-dossiers
   * @param dossier
   */
  calculerTailleDossier(dossier: Dossier): number {
    let taille = 0;

    dossier.fichiers.forEach(fic => taille += fic.taille);
    dossier.sousDossiers.forEach(sousDossier => {
      taille += this.calculerTailleDossier(sousDossier);
    });

    return taille;
  }

  /**
   * lorsque l'utilisateur tente de télécharger 1 ou + fichiers mais que 1 ou + n'existent plus physiquement
   * il a la possibilité de supprimer les références mortes
   **/
  supprimerReferencesMortes() {
    let fichierDossier = new FichierDossier();
    fichierDossier.fichiers = [];
    fichierDossier.fichiers = [...fichierDossier.fichiers, ...this.selectedFiles];
    fichierDossier.dossiers = [];
    fichierDossier.dossiers = [...fichierDossier.dossiers, ... this.selectedFolders];
    fichierDossier.id = this.id();
    fichierDossier.apiEndPoint = this.apiEndPoint();

    let startLoader = setTimeout(() => {
      this.fonctionsService.loading_screen(true);
    }, 300);
    this.http.post<FichierDossier, Dossier>('Files/DeleteNonExistent', fichierDossier).subscribe(resultat => {
      if (resultat) {
        this.fonctionsService.launch_toast(true, true);
        this.racineLocal = resultat;
        this.refreshDossierCourant(this.racineLocal);
      }
      clearTimeout(startLoader);
      this.clearSelection();
      this.fonctionsService.loading_screen(false);
      this.modalFichiersSupprimes.hide();
    }, () => {
      clearTimeout(startLoader);
      this.clearSelection();
      this.fonctionsService.loading_screen(false);
      this.fonctionsService.launch_toast(false, true);
      this.modalFichiersSupprimes.hide();
    });
  }

  clientReadWrite(){
    let isClient =  this.userProfileService.isGuest;
    if((isClient && this.accessPermision == AccessPermissionType.READANDWRITE) || (!isClient)) return true
     
    else return false;
  }
  private readonly sortFunctions: Record<string, (a: any, b: any) => number> = {
    file_type: (a, b) => this.compareStrings(
      this.getFileExtension(a.nom),
      this.getFileExtension(b.nom)
    ),
    file_name: (a, b) => this.compareStrings(
      this.removeExtension(a.nom),
      this.removeExtension(b.nom)
    ),
    file_size: (a, b) => this.compareNumbers(
      a.taille ?? 0,
      b.taille ?? 0
    ),
    modified: (a, b) => this.compareDates(
      a.dateCreation,
      b.dateCreation
    )
  };
  private compareStrings(a: string, b: string): number {
    return (a || '').toLowerCase().localeCompare((b || '').toLowerCase());
  }
  private compareNumbers(a: number, b: number): number {
    return a - b;
  }
  private compareDates(a: string, b: string): number {
    return new Date(a).getTime() - new Date(b).getTime();
  }
  sortTable(column: string): void {
    this.sortOrder = this.sortColumn === column ? !this.sortOrder : true;
    this.sortColumn = column;
  
    this.dossierCourant.fichiers.sort((a, b) => {
      const compareFn = this.sortFunctions[column] || ((a, b) => this.compareStrings(
        a[column]?.toString() ?? '',
        b[column]?.toString() ?? ''
      ));
      return this.sortOrder ? compareFn(a, b) : -compareFn(a, b);
    });
  }
  onKeyUp(event: KeyboardEvent, column: string): void {
    console.log(event.key);
    
    if (event.key === 'Enter' || event.key === ' ') {
      this.sortTable(column);
      event.preventDefault();
    }
  }

}

class FichierDossier {
  fichiers: Fichier[];
  dossiers: Dossier[];
  id: number;
  apiEndPoint: string;
}
